import { render, staticRenderFns } from "./ResetPasswordAmin.vue?vue&type=template&id=4482565d&scoped=true"
import script from "./ResetPasswordAmin.vue?vue&type=script&lang=js"
export * from "./ResetPasswordAmin.vue?vue&type=script&lang=js"
import style0 from "./ResetPasswordAmin.vue?vue&type=style&index=0&id=4482565d&prod&lang=scss&scoped=true"
import style1 from "./ResetPasswordAmin.vue?vue&type=style&index=1&id=4482565d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4482565d",
  null
  
)

export default component.exports